import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withStyles} from 'material-ui/styles';
import styles from './style/styles';
import {showAddGlobalButton} from '../../components/permissions/permissions';
import PagesGrid from './PagesGrid';
import PagesFilters from './PagesFilters';
import AddNewPageDialog from './AddNewPageDialog';
import {Heading} from '../../components/heading/heading';
import ScrollToTop from '../../components/scroll-top/ScrollToTop';
import {fetchSites} from '../sites/thunks';
import {
    fetchedPages,
    selectPageType,
    closeAddPagePopup,
    selectPageTagsDestination,
    selectPageTagsContinent,
    selectPageTagsTripFormat,
    selectPageTagsTypeOfWork,
    selectPageTagsTypeOfWorkTag,
    selectPageTagsTypeOfWorkGroup,
    selectPageTagsAll,
    hasError
} from './actions';
import {
    setGridFilter,
    unsetGridFilter
} from '../grid/actions';
import {
    fetchPageTypes,
    fetchPageTagsByPageType,
    createPage
} from './thunks';

class PagesSettings extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
        };
    }
    onFiltersApply() {
        this._child.reload();
    }

    componentWillMount() {
        this.props.fetchPageTypes();
        this.props.fetchSites();
    }

    selectPageType = (pageTypeId) => {
        this.props.fetchPageTagsByPageType(pageTypeId);
        this.props.selectPageType(pageTypeId);
    }
   

    setFilter = (filter, value) => {
        // ugly hack, material ui next beta dd input sucks
        if (filter === 'site_id' && value === 999) {
            value = 0;
        }
        if (filter === 'site_id' && value === -1) {
            this.props.unsetGridFilter(filter, value, this.props.gridId)
        } else if (filter === 'title' && value === '') {
            this.props.unsetGridFilter(filter, value, this.props.gridId)
        } else if (filter === 'page_type_id' && value === -1) {
            this.props.unsetGridFilter(filter, value, this.props.gridId)
        } else {
            this.props.setGridFilter(filter, value, this.props.gridId)
        }
    }

    resetGridFilters = (filters) => {
        filters.map(filter =>
            this.props.unsetGridFilter(filter.id, filter.value, this.props.gridId)
        )
    }

    handleClickOpenAddDialog = () => {
        this.setState({
            open: true,
        });
    }

    handleAddNewPageSubmit = (selectedPageType, selectedPageTags) => {
        this.props.createPage(selectedPageType, selectedPageTags);

        this.setState({
            open: false,
        });
    }

    handleCloseAddDialog = () => {
        this.props.closeAddPagePopup();

        this.setState({
            open: false,
        });
    }

    render() {

        return (
            <div>
                <Heading
                    title={'Pages List'}
                    buttonTitle={'Add New Page'}
                    buttonAction={this.handleClickOpenAddDialog.bind(this)}
                    showButton={showAddGlobalButton}
                />
                <PagesFilters
                    pageTypes={this.props.pageTypes}
                    sites={this.props.sites}
                    filters={this.props.pageFilters}
                    onFiltersApply={this.onFiltersApply.bind(this)}
                    setFilter={this.setFilter.bind(this)}
                    resetFilters={this.resetGridFilters.bind(this)}
                />
                <PagesGrid
                    ref={(child) => {this._child = child; }}
                    pages={this.props.gridPages}
                    gridId={this.props.gridId}
                    onFetchedItems={(data, totalPages) => {
                        this.props.fetchedPages(data, totalPages);
                    }}
                />
                <AddNewPageDialog
                    pageTypes={this.props.pageTypes}
                    pageTags={this.props.pageTags}
                    classes={this.props.classes}
                    open={this.state.open}
                    selectedPageType={this.props.selectedPageType}
                    selectPageType={this.selectPageType}
                    selectedPageTagsDestination={this.props.selectedPageTagsDestination}
                    selectedPageTagsContinent={this.props.selectedPageTagsContinent}
                    selectedPageTagsTripFormat={this.props.selectedPageTagsTripFormat}
                    selectedPageTagsTypeOfWork={this.props.selectedPageTagsTypeOfWork}
                    selectedPageTagsTypeOfWorkTag={this.props.selectedPageTagsTypeOfWorkTag}
                    selectedPageTagsTypeOfWorkGroup={this.props.selectedPageTagsTypeOfWorkGroup}
                    selectedPageTagsAll={this.props.selectedPageTagsAll}
                    selectPageTagsDestination={this.props.selectPageTagsDestination}
                    selectPageTagsContinent={this.props.selectPageTagsContinent}
                    selectPageTagsTripFormat={this.props.selectPageTagsTripFormat}
                    selectPageTagsTypeOfWork={this.props.selectPageTagsTypeOfWork}
                    selectPageTagsTypeOfWorkTag={this.props.selectPageTagsTypeOfWorkTag}
                    selectPageTagsTypeOfWorkGroup={this.props.selectPageTagsTypeOfWorkGroup}
                    selectPageTagsAll={this.props.selectPageTagsAll}
                    handleClose={this.handleCloseAddDialog}
                    handleSubmit={this.handleAddNewPageSubmit}
                    hasError={this.props.hasError}
                    metaError={this.props.metaError}
                />
                <ScrollToTop />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    gridPages: state.pages.all,
    pageFilters: state.grid.pagesGrid.filtered,
    pageTypes: state.pages.types,
    sites: state.sites.allIncludingMaster,
    pageTags: state.pages.tagsByPageType,
    selectedPageType: state.pages.selectedPageType,
    selectedPageTagsDestination: state.pages.selectedPageTagsDestination,
    selectedPageTagsContinent: state.pages.selectedPageTagsContinent,
    selectedPageTagsTripFormat: state.pages.selectedPageTagsTripFormat,
    selectedPageTagsTypeOfWork: state.pages.selectedPageTagsTypeOfWork,
    selectedPageTagsTypeOfWorkTag: state.pages.selectedPageTagsTypeOfWorkTag,
    selectedPageTagsTypeOfWorkGroup: state.pages.selectedPageTagsTypeOfWorkGroup,
    selectedPageTagsAll: state.pages.selectedPageTagsAll,
    metaError: state.pages.error,
});

const ConnectedPagesSettings = connect(mapStateToProps, {
    fetchedPages,
    setGridFilter,
    unsetGridFilter,
    fetchPageTypes,
    fetchPageTagsByPageType,
    fetchSites,
    createPage,
    selectPageType,
    selectPageTagsDestination,
    selectPageTagsContinent,
    selectPageTagsTripFormat,
    selectPageTagsTypeOfWork,
    selectPageTagsTypeOfWorkTag,
    selectPageTagsTypeOfWorkGroup,
    selectPageTagsAll,
    closeAddPagePopup,
    hasError
})(PagesSettings);

ConnectedPagesSettings.defaultProps = {gridId: 'pagesGrid' };

export default withStyles(styles)(ConnectedPagesSettings);


// WEBPACK FOOTER //
// ./src/containers/pages/index.js